import React, { useEffect, useState } from "react";
import "../../assets/scss/styles.scss";
import location from "../../assets/img/location-icon-green.svg";
import arrow from "../../assets/img/dropdown-arrow.png";
import { useClickOutside } from "../../utils/hooks/useClickOutside";
import { getCities } from "../../modules/get-city";
import { useSpecialties } from "../../modules/specialty-manager";
import { useBusinessTypes } from "../../modules/business-type-manager";
import { AutoPopulateInput } from "./search-auto-populate";
import { getZipcodes } from "../../modules/get-zipcodes";

export const SearchBarCommon = ({
    allTags,
    setAllTags,
    businessTypeTags,
    setBusinessTypeTags,
    selected,
    selectedBusinessTypes,
    suggested,
    handleSearch,
    searchTag,
    setSearchTag,
    searchLocation,
    setSearchLocation,
    searchBtn,
    setOverlay,
    setShowSearch,
    setShowContractors,
    showFiltersMobile,
    setShowFiltersMobile
}) => {
    const [specialties] = useSpecialties();
    const [businessTypes] = useBusinessTypes();
    const [serviceDropdownOpen, setServiceDropdownOpen] = useState(true);
    const [expanded, setExpanded] = useState(false);
    const [businessTypeExpanded, setBusinessTypeExpanded] = useState(false);

    const [ tempSearchLocation, setTempSearchLocation ] = useState(searchLocation)
    const [ serviceDropdown, setServiceDropdown ] = useState(false)
    const [ businessTypeDropdown, setBusinessTypeDropdown ] = useState(false)

    const cities = getCities();
    const zipcodes = getZipcodes();

    useEffect(() => {
        const serviceTagObjs = specialties.map((st) => ({
            id: specialties.indexOf(st),
            title: st,
            selected: false,
        }));
        if (allTags?.length === 0) {
            setAllTags(serviceTagObjs);
        }
    }, [specialties]);

    useEffect(() => {
        const businessTypeTagObjs = businessTypes.map((st) => ({
            id: businessTypes.indexOf(st),
            title: st,
            selected: false,
        }));
        if (businessTypeTags?.length === 0) {
            setBusinessTypeTags(businessTypeTagObjs);
        }
    }, [businessTypes]);

    const toggleServiceDropdown = () => setServiceDropdownOpen(!serviceDropdownOpen);
    const toggleBusinessTypeDropdown = () => setBusinessTypeDropdown(!businessTypeDropdown);
    const toggleExpanded = () => setExpanded(!expanded);
    const toggleBusinessTypeExpanded = () => setBusinessTypeExpanded(!businessTypeExpanded);

    const handleCheckboxChange = (service) => {
        const selectedService = allTags.find((t) => t.title === service);
        selectedService.selected = !selectedService.selected;
        setAllTags([...allTags]);
        handleSearch(searchLocation);
    };

    const handleBusinessTypeCheckboxChange = (type) => {
        const selectedType = businessTypeTags.find((t) => t.title === type);
        selectedType.selected = !selectedType.selected;
        setBusinessTypeTags([...businessTypeTags])
        handleSearch(searchLocation);
    };

    const handleClear = (e) => {
        e.preventDefault();
        setServiceDropdownOpen(false);
        setTempSearchLocation('')
        setSearchTag('')
        handleSearch('', true)
        setSearchLocation('')
        setAllTags(allTags.map(t => {return {...t, selected: false}}))
        setBusinessTypeTags(businessTypeTags.map(t => {return {...t, selected: false}}))
    };

    const renderBusinessTypeDropdown = () => {
        const maxVisibleServices = 7;
        return (
            <div className="service-dropdown">
                <div className="service-options">
                    {businessTypeTags
                        .slice(0, businessTypeExpanded ? businessTypeTags?.length : maxVisibleServices)
                        .map((type) => (
                            <div
                                key={type.id}
                                className="service-option"
                            >
                                <label>{type.title}</label>
                                <input
                                    type="checkbox"
                                    checked={type.selected}
                                    onChange={() => handleBusinessTypeCheckboxChange(type.title)}
                                />
                            </div>
                        ))}
                </div>
                {businessTypeTags?.length > maxVisibleServices && (
                    <div
                        className="toggle-more"
                        onClick={toggleBusinessTypeExpanded}
                    >
                        {businessTypeExpanded ? "show less" : "show more"}
                    </div>
                )}
            </div>
        );
    };

    const renderServiceDropdown = () => {
        const maxVisibleServices = 7;
        return (
            <div className="service-dropdown">
                <div className="service-options">
                    {allTags
                        .slice(0, expanded ? allTags?.length : maxVisibleServices)
                        .map((service) => (
                            <div
                                key={service.id}
                                className="service-option"
                            >
                                <label>{service.title}</label>
                                <input
                                    type="checkbox"
                                    checked={service.selected}
                                    onChange={() => handleCheckboxChange(service.title)}
                                />
                            </div>
                        ))}
                </div>
                {allTags?.length > maxVisibleServices && (
                    <div
                        className="toggle-more"
                        onClick={toggleExpanded}
                    >
                        {expanded ? "show less" : "show more"}
                    </div>
                )}
            </div>
        );
    };

    // activates search when clicking "update search" without having to first close the overlay on mobile
    const specificTargetHandler = (target)=> {
        if(serviceDropdown){
            if (target.classList.contains('fac-update-search')) {
                setSearchLocation(tempSearchLocation)
                handleSearch(tempSearchLocation)
                setShowSearch(false)
                setShowContractors(true)
            }
        }
    }

    // use the hook to handle the outside click
    const domNode = useClickOutside(() => {
        if(serviceDropdown){
            setServiceDropdown(false);
            if(setOverlay) {
                setOverlay(false)
            }
        }
    }, specificTargetHandler)

    const handleSubmit = (e) => {
        e.preventDefault();
        // handleSearch(searchLocation);

        if(e.key && e.key != 'Enter') {
            return false;
        }

        let facSearchLocation = document.querySelector('.fac-input-location-field').value;

        setSearchLocation(facSearchLocation)
        handleSearch(facSearchLocation)
        setShowSearch(false)
        setShowContractors(true)
        setShowFiltersMobile(false);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowFiltersMobile(false);
    }

    return (
        <div className="fac-searchbar">
            <form id="fac-search" className="fac-search-wrapper">
                {/* Location Input */}
                <div className="fac-searchbar-input-wrapper" ref={domNode}>
                    <div>
                        <p className="fac-searchbar-input-title search-heading"><strong>Project Location</strong></p>
                        <AutoPopulateInput
                            data={{ cities, zipcodes }}
                            inputValue={tempSearchLocation}
                            setInputValue={setTempSearchLocation}
                            icon={location}
                        />
                    </div>
                    {/* Search Button */}
                    {!showFiltersMobile &&
                        <div className="fac-searchbar-button-container">
                            <button
                                className="fac-btn fac-btn-primary fac-update-search"
                                type="submit"
                                onClick={(e) => {
                                    handleSubmit(e)
                                }}
                            >
                                {searchBtn}
                            </button>
                        </div>
                    }
                </div>
                <div className="filterLabelContainer">
                    <p>Filters:</p>
                    {(selected?.length > 0 || selectedBusinessTypes?.length > 0) &&
                        <span className="clearFilterButton" onClick={handleClear}>clear</span>
                    }
                </div>
                <div className="fac-searchbar-input-preview-wrapper">
                    {/* Service Dropdown Component */}
                    <div className={`fac-searchbar-input-wrapper ${!showFiltersMobile && "dropdown-input-wrapper"}`}>
                        <div
                            className="label-wrapper"
                            onClick={toggleServiceDropdown}
                        >
                            <span>
                                {selected?.length
                                    ? `Services (${selected?.length})`
                                    : "Services"}
                            </span>
                            {!showFiltersMobile &&
                                <span>
                                    <img src={arrow} className={serviceDropdownOpen ? 'dropdownActive' : ''}/>
                                </span>
                            }
                        </div>
                        {serviceDropdownOpen && renderServiceDropdown()}
                    </div>
                </div>
                <div className="fac-searchbar-input-preview-wrapper">
                    {/* Business Type Dropdown Component */}
                    <div className={`fac-searchbar-input-wrapper ${!showFiltersMobile && "dropdown-input-wrapper"}`}>
                        <div
                            className="label-wrapper"
                            onClick={toggleBusinessTypeDropdown}
                        >
                            <span>
                                {selectedBusinessTypes?.length
                                    ? `Contractor type (${selectedBusinessTypes?.length})`
                                    : "Contractor type"}
                            </span>
                            {!showFiltersMobile &&
                                <span>
                                    <img src={arrow} className={businessTypeDropdown ? 'dropdownActive' : ''}/>
                                </span>
                            }
                        </div>
                        {(businessTypeDropdown || showFiltersMobile) && renderBusinessTypeDropdown()}
                    </div>
                </div>

                {/* Search Button */}
                {showFiltersMobile &&
                    <div className="fac-searchbar-button-container fac-searchbar-button-container-mobile">
                        <button
                            className="fac-btn fac-btn-primary fac-update-search fac-update-search-mobile"
                            type="submit"
                            onClick={(e) => {
                                handleSubmit(e)
                            }}
                        >
                            Apply
                        </button>
                        <button
                            className="fac-btn fac-cancel-button"
                            onClick={(e) => {
                                handleCancel(e)
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                }
            </form>
        </div>
    );
};
